export default {
  link_expired: "Bağlantının süresi doldu",
  accountVerified: "Hesap başarıyla etkinleştirildi! Yolculuğa başlamak için giriş yapın.",
  gmi: "Giriş yap",
  Sign_In :"Oturum Aç",
  Creating_Account: "Hesap Oluşturma",
};
